import React from 'react'
import PropTypes from 'prop-types'

import style from './style.css'

export default class AttributeGroup extends React.Component {
  
  render() {
    return (
      <div className={style.attributeGroup}>
        <div className={style.title}>{this.props.title}</div>
        {this.props.children}
      </div>
    )
  }

}
